import styled, { css } from 'styled-components';
import { getTypographyStyles, SYS_SIZE_FIXED_50, SYS_SIZE_FIXED_100, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_1600, SYS_SIZE_FIXED_1800, SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL, SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, getMargins, SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import { IconButton } from '../icon-button/index.js';
import {} from './index.js';
export const StyledNavigationBar = styled.ul `
  margin: 0;
  padding: 0;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  scrollbar-width: none;
  flex-wrap: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StyledListItem = styled.li `
  list-style-type: none;
  flex: 1 0 auto;
  display: flex;
`;
export const StyledNavigationBarItemInner = styled.span `
  position: relative;
  align-items: center;
  display: flex;
  gap: ${(props) => props.size === 'sm' ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_150};

  ${(props) => props.active &&
    css `
      &::before {
        position: absolute;
        bottom: -${SYS_SIZE_FIXED_100};
        left: 0;
        content: '';
        width: 100%;
        height: ${SYS_SIZE_FIXED_50};
        background-color: ${props.theme.sem.color.navigation.foreground
        .indicator.active};
      }
    `}
`;
export const StyledNavigationBarAnchor = styled.a `
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  outline-offset: -2px;

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
  ${(props) => css `
    min-height: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1200
    : SYS_SIZE_FIXED_1400};

    min-width: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1600
    : SYS_SIZE_FIXED_1800};

    color: ${props.active
    ? props.theme.sem.color.navigation.foreground.text.active
    : props.theme.sem.color.navigation.foreground.text.idle};

    ${getTypographyStyles(props.size === 'sm'
    ? SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL
    : SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL)};
    padding: 0
      ${props.size === 'sm' ? SYS_SPACE_FIXED_200 : SYS_SPACE_FIXED_300};
  `}

  &:hover {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.interactive};
  }

  &:active {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.active};
  }
`;
export const StyledNavigationBarButton = styled.button `
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline-offset: -2px;

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
  ${(props) => css `
    min-height: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1200
    : SYS_SIZE_FIXED_1400};

    min-width: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1600
    : SYS_SIZE_FIXED_1800};

    color: ${props.active
    ? props.theme.sem.color.navigation.foreground.text.active
    : props.theme.sem.color.navigation.foreground.text.idle};

    ${getTypographyStyles(props.size === 'sm'
    ? SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL
    : SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL)};

    padding: 0
      ${props.size === 'sm' ? SYS_SPACE_FIXED_200 : SYS_SPACE_FIXED_300};
  `}

  &:disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.disabled};
  }

  &:hover:not(:disabled) {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.interactive};
  }

  &:active:not(:disabled) {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.active};
  }
`;
export const StyledNavigationBarContainer = styled.nav `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
`;
export const StyledIconButton = styled(IconButton) `
  flex-shrink: 0;
`;
//# sourceMappingURL=index.styles.js.map